import React from 'react';
import { useState, useEffect } from 'react';
import { PageHeader } from '../components/page-headers/page-headers';
import {
  Row,
  Col,
  Input,
  Form,
  Upload,
  message,
  Switch,
  Table,
  Select,
  Popconfirm,
  Button,
  Modal,
  Tag,
  DatePicker,
  Radio,
  Spin,
  Badge,
  Tooltip,
} from 'antd';
import axios from '../backendService'; // Import axios for API requests
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import { BiEditAlt } from 'react-icons/bi';
import { MdDelete } from 'react-icons/md';

const LecturesManagement = () => {
  const [videoData, setVideoData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [openDisable, setOpenDisable] = useState(false);
  const [currVideo, setCurrVideo] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([])

  const fetchData = async () => {
    const response = await axios.get('/videos/get-all-scheduled-videos');
    const sortedVideos = response.data.videos.sort(
      (a, b) => new Date(`${b.publishDate} ${b.startTime}`) - new Date(`${a.publishDate} ${a.startTime}`),
    );
    // console.log(sortedVideos, "dsdd---")
    setVideoData(sortedVideos);
    setFilteredData(sortedVideos)
    const courses = await axios.get(`/courses`);
    const trueCourses = courses.data.data.filter((course) => course.isActive === true);
    setCourses(trueCourses);
    const batchresponse = await axios.get(`/batch`);
    const responseData = await batchresponse.data.allBatches;
    setBatchData(responseData);
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const filtereddataToShow = videoData.filter((item) =>
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (selectedCourse ? item.course._id === selectedCourse : true) &&
      (selectedBatch ? item.batches.some(batch => batch._id === selectedBatch) : true)
    );
    setFilteredData(filtereddataToShow);
    if (selectedCourse === undefined) {
      setSelectedBatch(null)
    }
  }, [searchQuery, selectedCourse, selectedBatch]);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (title) => (
        <Tooltip title={title}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '150px',
            }}
          >
            {title}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Teacher',
      dataIndex: 'teacher',
      key: 'teacher',
      align: 'center',
      render: (teacher) => <span className="flex items-center justify-center">{teacher.userName}</span>,
    },
    {
      title: 'Publish Date',
      dataIndex: 'publishDate',
      key: 'publishDate',
      align: 'center',
      render: (publishDate) => <span className="flex items-center justify-center">{publishDate}</span>,
    },
    {
      title: 'Start Date',
      dataIndex: 'startTime',
      key: 'startTime',
      align: 'center',
      render: (startTime) => <span className="flex items-center justify-center">{startTime}</span>,
    },
    {
      title: 'End Date',
      dataIndex: 'endTime',
      key: 'endTime',
      align: 'center',
      render: (endTime) => <span className="flex items-center justify-center">{endTime}</span>,
    },
    {
      title: 'Course',
      dataIndex: 'course',
      key: 'course',
      align: 'center',
      render: (course) => <span className="flex items-center justify-center">{course.courseName}</span>,
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
      align: 'center',
      render: (subject) => <span className="flex items-center justify-center">{subject.subjectName}</span>,
    },
    {
      title: 'Chapter',
      dataIndex: 'chapter',
      key: 'chapter',
      align: 'center',
      render: (chapter) => <span className="flex items-center justify-center">{chapter.chapterName}</span>,
    },
    {
      title: 'Topic',
      dataIndex: 'topic',
      key: 'topic',
      align: 'center',
      render: (topic) => <span className="flex items-center justify-center">{topic.topicName}</span>,
    },
    {
      title: 'Batches',
      dataIndex: 'batches',
      key: 'batches',
      align: 'center',
      render: (batches) => (
        <span>
          {batches.map((batch) => (
            <Tag color="blue">
              {batch.name}
            </Tag>
          ))}
        </span>
      ),
    },

    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center gap-3">
          <Tooltip title={`Disable Lecture`}>
            <MdDelete className="mx-2 w-4 h-4 cursor-pointer" onClick={() => handleVideoDisable(record._id)} />
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleVideoDisable = (id: string) => {
    setCurrVideo(id);
    setOpenDisable(true);
  };

  const closeDisableModal = () => {
    setCurrVideo(null);
    setOpenDisable(false);
  };

  const handleDisable = async () => {
    try {
      let data = {
        id: currVideo,
      };
      const response = await axios.post(`/videos/disable-video/`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.data.message === 'Video streaming disabled') {
        message.success(response.data.message);
        fetchData();
        closeDisableModal();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Handle search query input change
  const onSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const onCourseSelect = async (val) => {
    setSelectedCourse(val);
    setFilteredBatches(batchData.filter((batch) => batch.course._id.toString() === val));
  };
  const handleBatchSelect = (selectedId) => {
    setSelectedBatch(selectedId)
    // console.log('curreenttt batchesssssss', selectedId);
  };

  // Filter the data based on the search query
  // const filteredData = videoData.filter((item) => item.title.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title="  "
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <>
              <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
                <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                  <div className="w-full flex items-center justify-between gap-[5px]">
                    <div style={{ width: '19%' }}>
                      <h1 className="mb-0 inline-block text-ellipsis text-[18px] font-semibold sm:text-center w-full">
                        Scheduled Lectures
                      </h1>
                    </div>
                    <div className='flex justify-between' style={{ width: '81%' }}>
                      <div style={{ width: '30%' }}>
                        <Input
                          allowClear
                          // className='w-full'
                          style={{ width: '100%', height: '40px', padding: '0 20px', border: '1px solid #d9d9d9', borderRadius: '4px' }}
                          value={searchQuery}
                          onChange={onSearchQueryChange}
                          placeholder="Search By Title"
                        />
                      </div>
                      <div style={{ width: '20%' }}>
                        <Select className='w-full' placeholder="Select Course" value={selectedCourse} onChange={onCourseSelect} allowClear>
                          {courses.map((item) => (
                            <Option key={item._id} value={item._id}>
                              {item.courseName}
                            </Option>
                          ))}
                        </Select>
                      </div>
                      <div style={{ width: '40%' }}>
                        <Select
                          className='w-full'
                          disabled={filteredBatches.length === 0}
                          placeholder="Select batch"
                          value={selectedBatch}
                          onChange={handleBatchSelect}
                          allowClear
                        >
                          {
                            filteredBatches.map((batch) => (
                              <Select.Option key={batch.name} value={batch._id}>
                                {batch.name}
                              </Select.Option>
                            ))
                          }
                        </Select>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="mt-0.5">
                  <GlobalUtilityStyle>
                    <PaginationStyle>
                      <div className="ant-pagination-custom-style table-responsive hover-tr-none table-th-shape-none table-last-th-text-right table-th-border-none table-head-rounded table-selection-col-pl-25 table-tr-selected-background-transparent table-td-border-none bg-white dark:bg-transparent rounded-[10px] ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-none ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-none">
                        <Table
                          dataSource={filteredData}
                          columns={columns}
                          rowKey={(record) => record._id}
                          pagination={{
                            defaultPageSize: 7,
                            total: videoData.length,
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            className:
                              '[&>.ant-pagination-total-text]:border-none ssm:[&>.ant-pagination-total-text]:w-full [&>.ant-pagination-total-text]:text-center [&>.ant-pagination-total-text]:text-dark dark:[&>.ant-pagination-total-text]:text-white87 [&>.ant-pagination-total-text]:font-medium [&>.ant-pagination-total-text]:text-[17px md:justify-center',
                          }}
                        />
                      </div>
                    </PaginationStyle>
                  </GlobalUtilityStyle>
                </div>
              </div>
            </>
          </Col>
        </Row>
      </main>
      {/* Disable modal */}
      <Modal
        title={
          <div>
            <h1>Are you sure you want to disable this lecture?</h1>
            <span className="text-sm font-normal">
              This will prevent lecture from streaming at scheduled time. This action will not delete lecture video
              file.
            </span>
          </div>
        }
        open={openDisable}
        onCancel={closeDisableModal}
        footer={null}
      >
        <div className="flex items-center justify-end gap-2">
          <Button onClick={closeDisableModal} type={'ghost'}>
            Cancel
          </Button>
          <Button onClick={handleDisable} type={'primary'}>
            Disable
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default LecturesManagement;
